/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The Prefecture model module.
 * @module model/Prefecture
 * @version 1.0.0
 */
export default class Prefecture {
  /**
   * Constructs a new <code>Prefecture</code>.
   * @alias module:model/Prefecture
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>Prefecture</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Prefecture} obj Optional instance to populate.
   * @return {module:model/Prefecture} The populated <code>Prefecture</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Prefecture()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {String} name
   */
  name = undefined
}
